declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
    dataLayer?: unknown[];
  }
}

// Mesma regra do Meta Pixel: não medir ambiente de desenvolvimento,
// para não contaminar relatórios e públicos do GA4.
export function isGaDisabled(): boolean {
  if (typeof window === "undefined") return true;
  const host = window.location.hostname;
  return host === "localhost" || host === "127.0.0.1";
}

export function trackGaPageView(path: string) {
  if (isGaDisabled()) return;
  if (typeof window.gtag !== "function") return;
  window.gtag("event", "page_view", {
    page_path: path,
    page_location: window.location.href,
    page_title: document.title,
  });
}

export function trackGaEvent(name: string, params?: Record<string, unknown>) {
  if (isGaDisabled()) return;
  if (typeof window.gtag !== "function") return;
  window.gtag("event", name, params);
}
